import memoize from 'lru-memoize';

import {VariableInterpolator} from './variableInterpolator';

export function memoizeVariableDirtyHtmlInterpolation(limit = 1): typeof interpolateDirtyHtml {
  return memoize(limit, areInterpolateArgsEqual)(interpolateDirtyHtml);
}

function interpolateDirtyHtml(untrustedHtml: string, interpolator: VariableInterpolator): string {
  return interpolator.interpolateDirtyHtml(untrustedHtml);
}

type InterpolateParameter = Parameters<typeof interpolateDirtyHtml>[any];

function areInterpolateArgsEqual(a: InterpolateParameter, b: InterpolateParameter): boolean {
  if (a === b) {
    return true;
  }

  if (a instanceof VariableInterpolator && b instanceof VariableInterpolator) {
    return a.isEqual(b);
  }

  return false;
}
